import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Alert, Form, Card, Col, Row, FormTextarea } from "shards-react";
import CustomizedCardHeader from "../../components/customized-card-header/CustomizedCardHeader";
import CardHeaderUtils from "../../utils/CardHeaderUtils";
import MainCardComponent from "../../components/common/main-card-component/MainCardComponent";
import CheckBoxGroupComponent from "../../components/common/check-box-group-component/CheckBoxGroupComponent";
import { ResponsiblePrimaryButton } from "../../components/buttons/ResponsibleAmeButton";
import withLabelAndHelpText from "../../components/inputs/hocs/with-label-and-help-text/withLabelAndHelpText";

import Loading from "../../components/loading/Loading";

import { CustomizedCardBody } from "./style";
import SecurityUtils from "../../components/security-container/SecurityUtils";
import AuthService from "../../services/auth-service/AuthService";
import ShowTarget from "./ShowTarget";
import elementWithAllText from "../../components/inputs/hocs/element-with-all-text/elementWithAllText";

const TextAreaWithLabelAndHelpText = withLabelAndHelpText(FormTextarea);
const Target = elementWithAllText(ShowTarget);

const FormInfo = ({
    miniApp,
    alertTheme,
    alertMessage,
    alertArea,
    closeAlert,
    visible,
    showInputError,
    isAdmin,
    handleInput,
    handleSwitchStatus,
    handleSwitchChange,
    isFetching,
    editMiniApp,
    hasWriteMiniAppScope,
    hasWriteMiniAppAction,
    hasEditMiniAppScope
}) => {
    const [, setUserMiniappActions] = useState([]);

    useEffect(() => {
        async function getActions() {
            const isAdmin = AuthService.isAdmin();
            let actions = [];

            if (!isAdmin) {
                actions = await SecurityUtils.userMiniappActions(miniApp.slug);
            }

            setUserMiniappActions(actions);
        }
        getActions();
    }, [miniApp.slug]);

    const menu =
        miniApp &&
        miniApp.slug &&
        CardHeaderUtils.getMenuList("Editar", miniApp, miniApp.slug);

    let inputOptions = {
        isAdmin,
        miniApp,
        isEditScreen: true,
        showInputError,
        hasWriteMiniAppScope,
        hasWriteMiniAppAction,
        hasEditMiniAppScope
    };

    let checkBoxOptions = {
        miniApp,
        isAdmin,
        isEditScreen: true,
        hasWriteMiniAppScope,
        hasWriteMiniAppAction
    };

    return isFetching ? (
        <Loading showBrand={false} message={"Editando eitri-app"} />
    ) : (
        <React.Fragment>
            <Form onSubmit={editMiniApp}>
                <Card small className="mb-4">
                    <CustomizedCardHeader
                        className={"border-bottom"}
                        initialName={
                            miniApp &&
                            miniApp.name &&
                            `Eitri-App: ${miniApp.name}`
                        }
                        menuList={menu}
                    />
                    <CustomizedCardBody>
                        {miniApp && (
                            <React.Fragment>
                                <Alert
                                    className="mb-3"
                                    open={visible && alertArea === "formSubmit"}
                                    dismissible={closeAlert}
                                    theme={alertTheme}
                                >
                                    {alertMessage}
                                </Alert>
                                <hr />
                                <MainCardComponent
                                    options={inputOptions}
                                    handleInput={handleInput}
                                    miniApp={miniApp}
                                    readOnly={
                                        !hasWriteMiniAppScope &&
                                        !hasWriteMiniAppAction
                                    }
                                />

                                <Target
                                    label={"Application"}
                                    value={miniApp.target}
                                    helptext={"Application do eitri-app."}
                                />

                                <hr />
                                <CheckBoxGroupComponent
                                    options={checkBoxOptions}
                                    handleSwitchStatus={handleSwitchStatus}
                                    handleSwitchChange={handleSwitchChange}
                                />
                                <hr />

                                <Row>
                                    <Col sm="12">
                                        <TextAreaWithLabelAndHelpText
                                            label={"Descricao"}
                                            readOnly={
                                                !hasWriteMiniAppScope &&
                                                !hasWriteMiniAppAction
                                            }
                                            name={"description"}
                                            value={miniApp.description || ""}
                                            helptext={
                                                "Inserir descrição do eitri-app"
                                            }
                                            onChange={handleInput}
                                            rows={10}
                                        />
                                    </Col>
                                </Row>
                                <hr />
                                {isFetching ? (
                                    <div className="loader" />
                                ) : (
                                    <ResponsiblePrimaryButton
                                        name="bt_update_info"
                                        type="submit"
                                        disabled={isFetching}
                                    >
                                        Salvar alterações
                                    </ResponsiblePrimaryButton>
                                )}
                            </React.Fragment>
                        )}
                    </CustomizedCardBody>
                </Card>
            </Form>
        </React.Fragment>
    );
};

FormInfo.propTypes = {
    iosNativeExperienceValue: PropTypes.object,
    androidNativeExperienceValue: PropTypes.object,
    miniApp: PropTypes.object,
    alertTheme: PropTypes.string,
    alertMessage: PropTypes.string,
    alertArea: PropTypes.string,
    closeAlert: PropTypes.func,
    visible: PropTypes.bool,
    showInputError: PropTypes.func,
    onLoad: PropTypes.func,
    isAdmin: PropTypes.bool,
    hasWriteMiniAppScope: PropTypes.bool,
    hasWriteMiniAppAction: PropTypes.bool,
    handleInput: PropTypes.func,
    handleSwitchStatus: PropTypes.func,
    handleSwitchChange: PropTypes.func,
    isFetching: PropTypes.bool,
    editMiniApp: PropTypes.func
};

export default FormInfo;
